<template>
  <div
    class="details__status get-height"
    :class="`details__status--${statusCssClass}`"
  >
    {{ status ? $t(`${namespace}.${status}`) : '-' }}
  </div>
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    statusCssClass () {
      const statusList = {
        'WAITING_DRIVERS_ANSWERS': 'info',
        'CAR_ON_THE_WAY': 'primary',
        'WAITING_FOR_PASSENGER': 'warning',
        'CAR_ARRIVED': 'success',
        'IN_PROGRESS': 'success',
        'RIDE_ENDED': 'default',
        'CANCELED_BY_DRIVER': 'error',
        'CANCELED_BY_PASSENGER': 'error',
        'COULDNT_FIND_AVAILABLE_DRIVERS': 'error',
        'DRIVERS_REJECTED': 'error'
      }

      return statusList[this.status] || 'default'
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.status'
    }
  }
}
</script>

<style lang="scss" scoped>
.details__status {
  align-items: center;
  background-color: $gray-3;
  color: $gray-8;
  display: flex;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 800;
  height: 32px;
  justify-content: center;
  line-height: normal;
  text-transform: uppercase;
  white-space: nowrap;

  &.details__status--info {
    background-color: #2d9dcc;
    color: #fff;
  }

  &.details__status--primary {
    background-color: #036dc3;
    color: #fff;
  }

  &.details__status--error {
    background-color: #cc2e2d;
    color: #fff;
  }

  &.details__status--success {
    background-color: #2dbb54;
    color: #fff;
  }

  &.details__status--warning {
    background-color: $secondary;
    color: #fff;
  }

  &.details__status--default {
    background-color: #a1a1a1;
    color: #fff;
  }
}
</style>
